<template>
  <div class="media-list">
    <div class="breadcrumb-bar">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/classlist' }"
          >班级管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ breadcrumbItem }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main-box" v-if="step == 1">
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">班级基本信息</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="formClass" label-width="90px">
              <el-form-item label="班级名称:">
                <el-input
                  v-model="formClass.name"
                  :disabled="doWhat == 'view'"
                  style="width: 170px"
                  placeholder="请填写名称"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="班主任:"
                style="min-width：300px;margin-right:40px"
              >
                <teacherSelect
                  @teacherResult="teacherChgHandle1"
                  :mainTeacherName="formClass.mainTeacher"
                  :mainTeacherId="formClass.mainTeacherId"
                  :btnDisable="doWhat == 'view'"
                  >选择班主任</teacherSelect
                >
              </el-form-item>
              <el-form-item label="助教:">
                <!-- <ul> {{formClass.deputyArr.length}}
                  <li v-for="(item,index) in formClass.deputyArr" :key="index">{{item.name}}</li>
                </ul> -->
                <deputyTeacher
                  @deputyResult="deputyChgHandle"
                  :mainTeacherName="formClass.deputyTeacher"
                  :disabled="doWhat == 'view'"
                  >选择助教</deputyTeacher
                >
                <!-- <Select
                  v-model="formClass.deputyTeacher"
                  multiple
                  style="width: 170px"
                  placeholder="支持多选"
                  :disabled="doWhat == 'view'"
                >
                  <Option
                    v-for="item in teacherList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    >{{ item.label }}</Option
                  >
                </Select> -->
              </el-form-item>

              <br />
              <el-form-item label="班级分组:">
                <a href="javascript:;" @click="addOIDRange">
                  <Icon
                    type="ios-add-circle-outline"
                    size="30"
                    color="#C5C5C5"
                    v-if="doWhat != 'view'"
                  />
                </a>
              </el-form-item>
              <div v-if="formClass.groupList.length">
                <div v-for="(item, index) in formClass.groupList" :key="index">
                  <br />
                  <el-form-item label="分组名称:" style="margin-left: 32px">
                    <el-input
                      v-model="item.groupInfo.group_name"
                      :disabled="doWhat == 'view'"
                      style="width: 170px"
                      placeholder="请填写名称"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item label="班主任:">
                    <teacherSelect
                      @teacherResult="(row) => teacherChgHandle2(row, index)"
                      :mainTeacherName="
                        item.groupTeacherList.main &&
                        item.groupTeacherList.main.teacherName
                      "
                      :mainTeacherId="
                        item.groupTeacherList.main &&
                        item.groupTeacherList.main.teacherId
                      "
                      :disabled="doWhat == 'view'"
                      >班主任</teacherSelect
                    >
                  </el-form-item>
                  <el-form-item label="助教:">
                    <deputyTeacher
                      @deputyResult="(row) => deputyChgHandle2(row, index)"
                      :mainTeacherName="item.deputyList"
                      :disabled="doWhat == 'view'"
                      >助教</deputyTeacher
                    >
                  </el-form-item>
                  <a href="javascript:;" @click="removeGroup(item, index)">
                    <Icon
                      type="ios-remove-circle-outline"
                      size="30"
                      color="#C5C5C5"
                      v-if="doWhat != 'view'"
                    />
                  </a>
                  <!-- @click="delOIDRange(index)" -->
                  <!-- <a
                    href="javascript:;"
                    @click="delOIDRange(index)"
                    v-if="index != 0"
                  >
                    <Icon
                      type="ios-remove-circle-outline"
                      size="30"
                      color="#C5C5C5"
                      v-if="doWhat != 'view'"
                      @click="removeGroup(item)"
                    />
                  </a> -->
                  <!-- <a
                    v-if="index == formClass.groupList.length - 1"
                    href="javascript:;"
                    @click="addOIDRange"
                  >
                    <Icon
                      type="ios-add-circle-outline"
                      size="30"
                      color="#C5C5C5"
                      v-if="doWhat != 'view'"
                    />
                  </a> -->
                </div>
              </div>

              <br />
              <el-form-item label="开班时间:">
                <DatePicker
                  v-model="formClass.beginTime"
                  type="date"
                  placeholder="必填项"
                  format="yyyy-MM-dd"
                  placement="bottom-end"
                  :disabled="doWhat == 'view'"
                  @on-change="beginTimeChgHandle"
                ></DatePicker>
              </el-form-item>
              <el-form-item label="结束时间:">
                <DatePicker
                  v-model="formClass.finishTime"
                  type="date"
                  placeholder="必填项"
                  format="yyyy-MM-dd"
                  placement="bottom-end"
                  :disabled="doWhat == 'view'"
                  @on-change="finishTimeChgHandle"
                ></DatePicker>
              </el-form-item>
              <br />
              <el-form-item label="班级类型:">
                <el-select
                  v-model="formClass.status"
                  clearable
                  style="width: 175px"
                  :disabled="doWhat == 'view'"
                >
                  <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </Card>
      <Card>
        <div class="panel-box">
          <h3 class="panel-title">课包信息</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="formClass" label-width="150px">
              <el-form-item label="课程更新起始时间:">
                <DatePicker
                  v-model="formClass.startTime"
                  type="date"
                  placeholder="必填项"
                  format="yyyy-MM-dd"
                  placement="bottom-end"
                  :disabled="doWhat == 'view'"
                  @on-change="startTimeChgHandle"
                ></DatePicker>
              </el-form-item>
              <el-form-item label="更新周期:">
                <DatePicker
                  v-model="formClass.endTime"
                  type="date"
                  placeholder="更新周期"
                  format="yyyy-MM-dd"
                  placement="bottom-end"
                  disabled
                ></DatePicker>
              </el-form-item>
              <br />
              <el-form-item label="关联课包:">
                <el-table
                  ref="currPkg"
                  :data="currPkg"
                  stripe
                  border
                  tooltip-effect="dark"
                  v-if="currPkg.length > 0"
                >
                  <el-table-column
                    prop="pkgId"
                    label="课包ID"
                    align="center"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <a
                        href="javascript:;"
                        @click="viewPkg(scope.row, 'Class')"
                        style="color: #1d90e6"
                        >{{ scope.row.pkgId }}</a
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="pkgName"
                    label="课包名称"
                    align="center"
                    width="200"
                  >
                    <template slot-scope="scope">
                      <a
                        href="javascript:;"
                        @click="viewPkg(scope.row, 'Class')"
                        style="color: #1d90e6"
                        >{{ scope.row.pkgName }}</a
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="pkgLevel"
                    label="课包等级"
                    align="center"
                    width="200"
                  ></el-table-column>
                  <el-table-column
                    prop="image"
                    label="课包封面"
                    align="center"
                    width="110"
                  >
                    <template slot-scope="scope">
                      <img
                        :src="scope.row.image"
                        min-width="70"
                        :height="scope.row.image != '' ? 70 : 20"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="pkgCount"
                    label="课数量"
                    align="center"
                    width="200"
                  ></el-table-column>
                  <el-table-column
                    prop="pkgRemark"
                    label="备注"
                    align="center"
                    width="200"
                  ></el-table-column>
                </el-table>
                <!--
                <classAddPackage
                  @addPkg="clsssAddPkgHandle"
                  v-if="doWhat!='view'&&showChangePackage"
                />
                -->
                <classAddPackage
                  @addPkg="clsssAddPkgHandle"
                  v-if="doWhat != 'view' && !isEnabled"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </Card>
      <el-button
        type="primary"
        style="margin-left: 45%; margin-top: 30px; margin-bottom: 50px"
        @click="nextStep"
        :loading="loadingBtn"
        >下一步</el-button
      >
      <el-button @click="cancelEdit">取消</el-button>
    </div>
    <div class="main-box" v-else-if="step == 2">
      <Card style="margin-bottom:20px;max-height=40vw" v-if="doWhat != 'view'">
        <div class="panel-box">
          <h3 class="panel-title">所有学员</h3>
          <div class="panel-content">
            <queryStuBar @queryResult="stuAllQueryHandle" />
            <el-table
              ref="multipleTable"
              :data="stuAllData"
              stripe
              border
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="stuAllChange"
              v-loading.body="loading"
            >
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column
                prop="id"
                label="学员ID"
                align="center"
                width="110"
              >
                <template slot-scope="scope">
                  <a
                    href="javascript:;"
                    @click="viewStu(scope.row)"
                    style="color: #1d90e6"
                    >{{ scope.row.id }}</a
                  >
                </template>
              </el-table-column>

              <el-table-column
                prop="name"
                label="学员昵称"
                align="center"
                min-width="120"
              >
                <template slot-scope="scope">
                  <a
                    href="javascript:;"
                    @click="viewStu(scope.row)"
                    style="color: #1d90e6"
                    >{{ scope.row.name }}</a
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="weixinId"
                label="微信号"
                align="center"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="phone"
                label="家长手机号"
                align="center"
                width="200"
              ></el-table-column>
              <el-table-column
                prop="signupDate"
                label="报名时间"
                align="center"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="expireDate"
                label="会员有效期"
                align="center"
                min-width="120"
              >
                <template slot-scope="scope">
                  <span
                    v-if="
                      scope.row.expireDate == '2121-01-01' ||
                      scope.row.expireDate == null
                    "
                    style="color: red"
                    >永久有效</span
                  >
                  <span v-else
                    >{{
                      checkTime(scope.row.expireDate)
                        ? scope.row.expireDate
                        : "已过期"
                    }}
                    {{ scope.row.expireTag }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="status"
                label="学员账户状态"
                align="center"
                width="150"
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.status == 0" type="warning"
                    >注册</el-tag
                  >
                  <el-tag v-else-if="scope.row.status == 1" type="gray"
                    >激活</el-tag
                  >
                  <el-tag v-if="scope.row.status == 2" type="success"
                    >活跃</el-tag
                  >
                  <el-tag v-else-if="scope.row.status == 3" type="primary"
                    >到期</el-tag
                  >
                  <el-tag v-if="scope.row.status == 4" type="danger"
                    >注销</el-tag
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-button
              type="primary"
              @click="addStu"
              style="margin-top: 20px"
              icon="plus"
              >添加</el-button
            >
            <div class="pagination-box">
              <el-pagination
                @size-change="handleStuAllSizeChange"
                @current-change="handleStuAllCurrentChange"
                :current-page.sync="stuAllQueryParams.page"
                :page-sizes="[20, 50, 100]"
                :page-size="stuAllQueryParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="stuAllPageTotal"
              ></el-pagination>
            </div>
          </div>
        </div>
      </Card>
      <Card style="max-height=40vw">
        <div class="panel-box">
          <h3 class="panel-title">已添加学员</h3>
          <div class="panel-content">
            <queryStuBar
              @queryResult="stuSelQueryHandle"
              :className="false"
              :signupDate="false"
              :endTime="true"
              :joinTime="true"
              :groupName="true"
              :teacherId="true"
            />
            <el-table
              ref="multipleTable"
              :data="stuSelData"
              stripe
              border
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="stuSelChange"
            >
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column
                prop="id"
                label="学员ID"
                align="center"
                width="100"
              >
                <template slot-scope="scope">
                  <a
                    href="javascript:;"
                    @click="viewStu(scope.row)"
                    style="color: #1d90e6"
                    >{{ scope.row.id }}</a
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="学员昵称"
                align="center"
                min-width="120"
              >
                <template slot-scope="scope">
                  <a
                    href="javascript:;"
                    @click="viewStu(scope.row)"
                    style="color: #1d90e6"
                    >{{ scope.row.name }}</a
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="weixinId"
                label="微信号"
                align="center"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="phone"
                label="家长手机号"
                align="center"
                width="130"
              ></el-table-column>
              <!--<el-table-column prop="signupDate" label="报名时间" align="center" min-width="120"></el-table-column>-->
              <el-table-column
                prop="joinTime"
                label="入班时间"
                align="center"
                min-width="120"
              >
                <template slot-scope="scope">
                  <span v-if="isWeek">
                    {{ scope.row.joinTime }}
                    <span v-if="scope.row.joinTimeOrder == 0">(第1周)</span>
                    <span v-if="scope.row.joinTimeOrder != 0"
                      >(第{{ scope.row.joinTimeOrder }}周)</span
                    >
                    <!-- {{
                      checkWeekDiff(
                        scope.row.joinTime,
                        formClass.startTime,
                        scope.row.endTime,
                        formClass.classCount
                      )
                    }} -->
                  </span>
                  <span v-if="!isWeek">
                    {{ scope.row.joinTime }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="groupName"
                label="班级分组"
                align="center"
                width="130"
              ></el-table-column>
              <el-table-column
                prop=""
                label="助教老师"
                align="center"
                width="130"
              >
                <template slot-scope="scope">
                  <span
                    v-for="(item, index) in scope.row.groupTeacher"
                    :key="index"
                  >
                    {{ item.name }};
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="expireDate"
                label="会员有效期"
                align="center"
                min-width="120"
              >
                <template slot-scope="scope">
                  <span
                    v-if="
                      scope.row.expireDate == '2121-01-01' ||
                      scope.row.expireDate == null
                    "
                    style="color: red"
                    >永久有效</span
                  >
                  <span v-else
                    >{{
                      checkTime(scope.row.expireDate)
                        ? scope.row.expireDate
                        : "已过期"
                    }}
                    {{ scope.row.expireTag }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="startTime"
                label="学员课程时间"
                align="center"
                min-width="220"
              >
                <!-- :class="[
                      checkStuEndTime(
                        scope.row.endTime,
                        scope.row.expireDate
                      ).indexOf('有效期') != -1 && 'fontCoralShow',
                      checkStuEndTime(
                        scope.row.endTime,
                        scope.row.expireDate
                      ).indexOf('续费') != -1 && 'fontGreenShow',
                    ]" -->
                <!-- v-if="isWeek" -->
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.startTime }}
                    <span v-if="scope.row.startTimeOrder == 0">(第1周)</span>
                    <span v-if="scope.row.startTimeOrder != 0"
                      >(第{{ scope.row.startTimeOrder }}周)</span
                    >
                    <!-- (第{{
                      checkWeekDiff(
                        scope.row.startTime,
                        formClass.startTime,
                        scope.row.endTime,
                        formClass.classCount
                      )
                    }}周)  -->
                    至
                    {{
                      checkStuEndTime(scope.row.endTime, scope.row.expireDate)
                    }}
                  </span>
                  <!-- <span v-if="!isWeek">
                    {{ scope.row.startTime }}
                    至
                    {{
                      checkStuEndTime(scope.row.endTime, scope.row.expireDate)
                    }}
                  </span> -->
                </template>
              </el-table-column>
              <el-table-column
                prop="classStatus"
                label="在班状态"
                align="center"
                width="100"
              >
                 <template slot-scope="scope">
                  <!-- <el-tag v-if="scope.row.status == 0" type="danger"
                    >到期</el-tag
                  > -->
                  <el-tag v-if="scope.row.classStatus == 1" type="success"
                    >在营</el-tag
                  >
                  <el-tag v-else-if="scope.row.classStatus == 2" type="gray"
                    >转班</el-tag
                  >
                  <el-tag v-else-if="scope.row.classStatus == 5" type="danger"
                    >结课</el-tag
                  >
                  <el-tag v-else-if="scope.row.classStatus == 4" type="primary"
                    >毕业</el-tag
                  >
                </template>
              </el-table-column>
            </el-table>
            <div
              class="btnFlex"
              style="min-width: 140px; float: left; margin-top: 10px"
            >
              <el-button
                type="danger"
                @click="delStu"
                style="margin-right: 10px"
                v-if="doWhat != 'view'"
                icon="delete2"
                >删除</el-button
              >
              <stuAddClass
                @classResult="classChgHandle"
                :oldClass="Number(currClassId)"
                v-if="doWhat != 'view'"
                :len="stuSelMultSelection.length"
                :stuData="stuSelMultSelection"
                btnSize="normal"
                >转班</stuAddClass
              >
              <classGroup
                @classGroupResult="classGroupChgHandle"
                v-if="doWhat != 'view'"
                btnSize="normal"
                style="margin-left: 10px"
                :len="stuSelMultSelection.length"
                :classId="Number(currClassId)"
                >班级分组</classGroup
              >
              <stuChgTime
                @editClassTime="editClassStartTimeConfrim"
                :startTime="transToStr(formClass.beginTime)"
                :endTime="transToStr(formClass.finishTime)"
                :currEditClassId="Number(currClassId)"
                :kcTime="transToStr(formClass.startTime)"
                v-if="doWhat != 'view'"
                :chgStart="true"
                :len="stuSelMultSelection.length"
                :stuData="stuSelMultSelection"
                btnSize="normal"
                style="margin-left: 10px"
                :stuSelMultSelection="stuSelMultSelection"
                :classCount="formClass.classCount"
                :progressNum2="formClass.progressNum2"
                >修改开课时间</stuChgTime
              >
              <stuChgTime
                @editClassTime="editClassEndTimeConfrim"
                :startTime="transToStr(formClass.beginTime)"
                :endTime="transToStr(formClass.finishTime)"
                :currEditClassId="Number(currClassId)"
                :classCount="formClass.classCount"
                :expireDate1="formClass.expireDate1"
                :progressNum2="formClass.progressNum2"
                :kcTime="transToStr(formClass.startTime)"
                v-if="doWhat != 'view'"
                :chgEnd="true"
                :len="stuSelMultSelection.length"
                :stuData="stuSelMultSelection"
                btnSize="normal"
                style="margin-left: 10px"
                >修改结课时间</stuChgTime
              >
              <stuChgTime
                @editClassTime="editjoinTimeConfrim"
                :startTime="transToStr(formClass.beginTime)"
                :endTime="transToStr(formClass.finishTime)"
                :currEditClassId="Number(currClassId)"
                :classCount="formClass.classCount"
                :stujoinTime="formClass.stujoinTime"
                :expireDate1="formClass.expireDate1"
                :progressNum2="formClass.progressNum2"
                :kcTime="transToStr(formClass.startTime)"
                v-if="doWhat != 'view'"
                :joinTime="true"
                :len="stuSelMultSelection.length"
                btnSize="normal"
                style="margin-left: 10px"
                >修改入班时间</stuChgTime
              >
              <exprotClassStuList
                style="margin-left: 10px"
                :classId="Number(currClassId)"
                :className="formClass.name"
                v-if="doWhat != 'view'"
              ></exprotClassStuList>
            </div>
            <div class="pagination-box">
              <el-pagination
                @size-change="handleStuSelSizeChange"
                @current-change="handleStuSelCurrentChange"
                :current-page.sync="stuSelQueryParams.page"
                :page-sizes="[20, 50, 100]"
                :page-size="stuSelQueryParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="stuSelPageTotal"
              ></el-pagination>
            </div>
          </div>
        </div>
      </Card>
      <el-button
        type="primary"
        style="margin-left: 45%; margin-top: 30px; margin-bottom: 50px"
        @click="lastStep"
        >上一步</el-button
      >
      <el-button @click="finishEdit">完成</el-button>
    </div>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import classAddPackage from "../componentsEdu/classAddPackage";
import queryStuBar from "../componentsEdu/queryStuBar";
import stuAddClass from "../componentsEdu/stuAddClass";
import stuChgTime from "../componentsEdu/stuChgTime";
import classGroup from "../componentsEdu/classGroup";
import exprotClassStuList from "../componentsEdu/exprotClassStuList";
import teacherSelect from "../componentsEdu/teacherSelect";
import deputyTeacher from "../componentsEdu/deputyTeacher";

import moment from "moment";

import {
  formatDateString,
  filterMultyNum,
  nowDateToNowStr,
  compareTimeWithNow,
  dateStrToMs,
  calcWeek,
  dateStrToMs1,
} from "../commonEdu";
export default {
  name: "classAddNew",
  components: {
    classAddPackage,
    queryStuBar,
    stuAddClass,
    stuChgTime,
    exprotClassStuList,
    teacherSelect,
    classGroup,
    deputyTeacher,
  },
  data() {
    return {
      mainTeacher1: [],
      formClass: {
        name: "",
        groupName: "",
        level: "",
        mainTeacher: "",
        mainTeacher1: "",
        mainTeacherId: "",
        main_teacherId: "",
        deputyTeacher: [],
        deputyTeacherPackId: [],
        deputy_teacherId: [],
        startTime: "",

        packageId: "",
        beginTime: "",
        finishTime: "",
        endTime: "",
        classCount: "",
        progressNum2: "",
        expireDate1: "",
        stujoinTime: "", //入班时间
        signupDate: "",
        groupList: [],
        status: 1,
        deputyArr: [],
      },
      loadingBtn: false,

      statusList: [
        {
          value: 1,
          label: "正式班",
        },
        {
          value: 2,
          label: "试听班",
        },
      ],
      step: 1,
      stuAllData: [],
      stuAllMultSelection: [],
      stuAllQueryParams: {
        page: 1,
        pageSize: 20,
      },
      stuAllPageTotal: 0,
      stuSelData: [],
      stuSelMultSelection: [],
      stuSelQueryParams: {
        page: 1,
        pageSize: 20,
      },
      stuSelPageTotal: 0,
      loading: true,
      queryTerms: null,
      queryTermsForClsStu: null,
      currClassId: null,
      pkgId: "",
      //pkgName: "",
      teacherList: [],
      packTeachList: [],
      doWhat: "",
      currPkg: [],
      showChangePackage: true,
      isEnabled: false,
      breadcrumbItem: "",
      expireDate1: "", //会员有效期
      // kcTime: "", //课程更新时间
      isWeek: true,
      bjjksj: "",
    };
  },
  created() {
    // debugger
    if(this.$route.query.id){
      this.breadcrumbItem="编辑班级"
    }else{
      this.breadcrumbItem="建立班级"
    }
    if (this.$route.query.id != undefined) {
      this.currClassId = `${this.$route.query.id}`;
      if (this.$route.query.do != undefined) {
        this.doWhat = this.$route.query.do;
      }

      this.fetchTeacherList().then((res2) => {
        this.fetchClassDetail().then((res) => {
          if (res != null) {
            // debugger

            let m = JSON.parse(res).list[0];
            // debugger
            // 分组
            if (m.groupList) {
              this.formClass.groupList = m.groupList;
            }
            if (m.classType != 0) {
              // debugger
              this.formClass.status = m.classType;
            }

            // debugger
            this.formClass.name = m.name;
            this.formClass.level = m.level;
            if (m.mainTeacher != undefined) {
              this.formClass.mainTeacher = m.mainTeacher.name;
              this.formClass.mainTeacherId = m.mainTeacher.id;
              // this.formClass.mainTeacher = `${m.mainTeacher.id}`;
            }
            if (this.formClass.groupList.length === 0) {
              // debugger
              // this.addOIDRange();
            } else {
              this.formClass.groupList.forEach((item) => {
                item.deputyList = [];
                this.packTeachList.forEach((tea) => {
                  item.groupTeacherList &&
                    item.groupTeacherList.deputy &&
                    item.groupTeacherList.deputy.forEach((dep) => {
                      // debugger
                      if (tea.id == dep.teacherId) {
                        // debugger
                        item.deputyList.push(tea);
                      }
                    });
                });
                this.mainTeacher1.push(
                  item.groupTeacherList.main &&
                    item.groupTeacherList.main.teacherId
                );
                item.deputyListId = item.groupTeacherList.deputy.map((item) =>
                  String(item.teacherId)
                );
                // item.groupTeacherList.deputy_teacherId =
                //   item.groupTeacherList.deputy &&
                //   item.groupTeacherList.deputy.map((cu) => String(cu.teacherId));
              });
            }
            // this.formClass.groupList.forEach((item) => {
            //   item.groupTeacherList.deputy_teacherId =
            //     item.groupTeacherList.deputy &&
            //     item.groupTeacherList.deputy.map((cu) => String(cu.teacherId));
            //   this.mainTeacher1.push(item.groupTeacherList.main.teacherId);
            // });

            // console.log(this.formClass.groupList, 'grisospssss')

            this.formClass.deputyTeacher = [];
            this.formClass.startTime = m.startTime; //课程开始时间
            this.formClass.beginTime = m.beginTime; //班级开始时间
            this.formClass.finishTime = m.finishTime; //班级结束时间
            // console.log(this.formClass.finishTime)
            // debugger
            this.formClass.classCount = m.package.count; //周数
            this.formClass.progressNum2 = m.package.progress; //进度
            if (m.endTime != "") {
              this.formClass.endTime = m.endTime;
            }
            this.bjjksj = m.endTime;

            this.isEnabled = m.enabled;
            if (m.package != undefined) {
              let temp = {
                pkgId: m.package.packageId,
                pkgName: m.package.packageName,
                pkgLevel: m.package.level,
                image: m.package.image,
                pkgCount: m.package.count,
                pkgRemark: m.package.remark,
              };
              this.currPkg.push(temp);
              this.pkgId = `${m.package.packageId}`;
            }
            // for (let i in m.deputyTeacher) {
            this.formClass.deputyTeacher = m.deputyTeacher || [];
            // console.log(this.formClass.deputyTeacher, 'd')
            if (m.deputyTeacher && m.deputyTeacher.length) {
              this.formClass.deputyTeacherPackId =
                m.deputyTeacher &&
                m.deputyTeacher.map((item) => item.id.toString());
            }

            // console.log(this.formClass.deputyTeacherPackId, "teacherlist");
            // }
            this.fetchClsStu();
          }
        });
      });
    } else {
      // debugger
      this.fetchTeacherList();
      // this.addOIDRange();
    }
  },
  watch: {
    step(newVal, oldVal) {
      if (newVal == 2) {
        this.breadcrumbItem = this.formClass.name;
      } else if (newVal == 1&&!this.currClassId) {
        this.breadcrumbItem = "建立班级";
      }else if(newVal == 1&&this.currClassId!=""){
        this.breadcrumbItem = "编辑班级";
      }
    },
  },
  methods: {
    removeGroup(item, index) {
      if (item.groupInfo.id) {
        let contentTemp = "<ul><li>请确认是否删除所选分组。</li>";
        this.$Modal.confirm({
          title: "确认删除？",
          content: contentTemp,
          onOk: () => {
            // if (item.groupInfo.id) {
            let groupId = item.groupInfo.id;
            let params = {
              appId: this.$API.APPID,
              groupId: groupId || "", //必须，Int类型，班级分组的主id，
              classId: this.currClassId, //必须，班级ID
              confirmDel: "1",
            };
            // console.log(params, 47676877);

            this.$axios
              .post("/edu/eduAdmin/class/group_del", params)
              .then((response) => {
                if (response != null) {
                  if (response.data.rc == 0) {
                    // debugger
                    this.formClass.groupList.splice(index, 1);
                    this.$Message.success("删除成功!");
                  } else if (response.data.rc == -4) {
                    // debugger
                    alert(response.data.err);
                  }
                }
              });
            // } else {
            //   this.formClass.groupList.splice(index, 1);
            // }
          },
        });
      } else {
        this.formClass.groupList.splice(index, 1);
      }
    },
    classGroupChgHandle(val) {
      let groupId = val.groupId;
      let stuIds = [];
      for (let i in this.stuSelMultSelection) {
        stuIds.push(`${this.stuSelMultSelection[i].id}`);
      }
      let params = {
        appId: this.$API.APPID,
        stuIdList: stuIds, //必须，要分组的学生id列表
        groupId: groupId, //必须，Int类型，班级分组的主id，
        classId: this.currClassId, //必须，班级ID
      };
      // console.log(params, 47676877);

      this.$axios
        .post("/edu/eduAdmin/class/grouping", params)
        .then((response) => {
          if (response != null) {
            this.$Message.success("操作成功!");
            this.fetchClsStu();
          }
        });
    },
    addOIDRange() {
      this.formClass.groupList.push({
        groupInfo: {},
        groupTeacherList: {
          deputy: [],
          main: {},
          deputy_teacherId: [],
        },
      });
    },

    fetchClassDetail() {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          id: this.currClassId,
        };
        this.eduAxiosPostRequest("/edu/eduAdmin/class/list", params).then(
          (res) => {
            // let m = JSON.parse(res);

            if (res != null) {
              resolve(res);
            } else {
              reject(null);
            }
          }
        );
      });
    },
    teacherChgHandle1(teaArr) {
      this.mainTeacher = teaArr.id;
    },
    teacherChgHandle2(teaArr, index) {
      if (this.mainTeacher1.length <= this.formClass.groupList.length) {
        this.mainTeacher1[index] = teaArr.id;
      } else {
        this.mainTeacher1.push(teaArr.id);
      }
      //
      // console.log(this.mainTeacher1, 'asdasdsa');
    },
    deputyChgHandle(teaArr) {
      // debugger
      this.formClass.deputyTeacherPackId = teaArr;
    },
    // 助教
    deputyChgHandle2(row, index) {
      this.formClass.groupList.forEach((item, currentIndex) => {
        if (index === currentIndex) item.deputyListId = row;
      });
      // console.log(this.formClass, 'forClasssssssssssssss')
    },

    nextStep() {
      if (this.doWhat == "view") {
        this.step = 2;
        this.fetchStuList();
      } else {
        if (
          this.formClass.beginTime == "" ||
          this.formClass.beginTime == null
        ) {
          alert("开班时间是必填项");
          return;
        }
        if (
          this.formClass.finishTime == "" ||
          this.formClass.finishTime == null
        ) {
          alert("结束时间是必填项");
          return;
        }
        if (
          this.formClass.startTime == "" ||
          this.formClass.startTime == null
        ) {
          alert("课程更新起始时间是必填项");
          return;
        }
        if (
          this.checkStartAndBeginTime(
            this.formClass.beginTime,
            this.formClass.startTime
          )
        ) {
          alert("开班时间不能晚于课程更新起始时间");
          return;
        }
        if (this.pkgId == "") {
          alert("请关联课包");
          return;
        }
        var groupTeacher = [];
        if (this.formClass.groupList.length) {
          this.formClass.groupList.forEach((item, index) => {
            groupTeacher.push({
              groupName: item.groupInfo.group_name || "",
              main_teacherId: this.mainTeacher1.length
                ? this.mainTeacher1[index] || "".toString() || "".toString()
                : this.formClass.main_teacherId || "".toString(),
              deputy_teacherId: item.deputyListId || [],
              groupId: item.groupInfo.id || "",
            });
          });
        }
        this.loadingBtn = true;

        let params = {
          appId: this.$API.APPID,
          name: this.formClass.name,
          level: this.formClass.level,
          mainTeacher: this.mainTeacher
            ? this.mainTeacher.toString()
            : this.formClass.mainTeacherId.toString(),
          deputyTeacher: this.formClass.deputyTeacherPackId || [],
          packageId: this.pkgId,
          startTime: formatDateString(this.formClass.startTime),
          beginTime: formatDateString(this.formClass.beginTime),
          finishTime: formatDateString(this.formClass.finishTime),
          classType: this.formClass.status,
          groupTeacher: groupTeacher,
        };
        // console.log(params, "22222222222222");
        // debugger;
        if (this.currClassId != null) {
          params.id = this.currClassId;
        }
        this.eduAxiosPostRequest("/edu/eduAdmin/class/save", params).then(
          (res) => {
            if (res != null) {
              this.loadingBtn = false;

              let m = JSON.parse(res);
              // console.log(m);
              this.currClassId = `${m.id}`;
              this.step = 2;
              this.fetchStuList();
              if (this.formClass.endTime == "") {
                this.fetchClassDetail().then((res) => {
                  if (res != null) {
                    let m = JSON.parse(res).list[0];
                    if (m.endTime != "") {
                      this.formClass.endTime = m.endTime;
                    }
                  }
                });
              }
              this.fetchClsStu();
            }
          }
        );
      }
    },

    checkStartAndBeginTime(beginTime, startTime) {
      let time = new Date(beginTime);
      let begin = parseInt(time.getTime() / 1000);
      // console.log(begin);
      time = new Date(startTime);
      let start = parseInt(time.getTime() / 1000);
      // console.log(start);
      if (begin > start) {
        return true;
      } else {
        return false;
      }
    },
    fetchStuList() {
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
      };
      if (this.queryTerms != null) {
        if (this.queryTerms.id != "") {
          params.id = this.queryTerms.id;
        }
        if (this.queryTerms.stuName != "") {
          params.stuName = this.queryTerms.stuName;
        }
        if (this.queryTerms.className != "") {
          params.className = this.queryTerms.className;
        }
        if (this.queryTerms.phone != "") {
          params.phone = filterMultyNum(this.queryTerms.phone);
        }
        if (this.queryTerms.weixinId != "") {
          params.weixinId = this.queryTerms.weixinId;
        }

        if (
          this.queryTerms.signupDate &&
          this.queryTerms.signupDate.length == 2
        ) {
          if (
            this.queryTerms.signupDate[0] != null &&
            this.queryTerms.signupDate[1] != null
          ) {
            params.signupDate = [
              formatDateString(this.queryTerms.signupDate[0]),
              formatDateString(this.queryTerms.signupDate[1]),
            ];
          }
        }
        if (
          this.queryTerms.expireDate &&
          this.queryTerms.expireDate.length == 2
        ) {
          if (
            this.queryTerms.expireDate[0] != null &&
            this.queryTerms.expireDate[1] != null
          ) {
            if (
              this.queryTerms.expireDate[0] == "2121-01-01" &&
              this.queryTerms.expireDate[1] == "2121-01-01"
            ) {
              params.expireDate = ["", ""];
            } else {
              params.expireDate = [
                formatDateString(this.queryTerms.expireDate[0]),
                formatDateString(this.queryTerms.expireDate[1]),
              ];
            }
          }
        }
        if (this.queryTerms.status !== null && this.queryTerms.status !== "") {
          params.status = this.queryTerms.status;
        }
      }
      params.pageSize = this.stuAllQueryParams.pageSize;
      params.page = this.stuAllQueryParams.page;
      this.eduAxiosPostRequest("/edu/eduAdmin/stu/list", params).then((res) => {
        if (res != null) {
          let m = JSON.parse(res);
          this.stuAllData = m.list;
          this.stuAllPageTotal = m.pager.total;
        }
        this.loading = false;
      });
    },
    fetchTeacherList() {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          pageSize: 500,
          page: 1,
        };
        this.eduAxiosPostRequest("/edu/eduAdmin/teacher/list", params).then(
          (res) => {
            if (res != null) {
              // debugger
              let m = JSON.parse(res).list;
              this.packTeachList = m;
              for (let i in m) {
                let temp = {
                  label: m[i].name,
                  value: `${m[i].id}`,
                };
                this.teacherList.push(temp);
              }
              resolve(m);
            } else {
              reject(null);
            }
          }
        );
      });
    },
    clsssAddPkgHandle(pkg) {
      this.pkgId = pkg.pkgId;
      //this.pkgName = pkg.pkgName;
      this.currPkg = [];
      /*
      let temp = {
        pkgName: pkg.pkgName,
        pkgLevel: pkg.level,
        pkgCount: pkg.count,
        pkgRemark: pkg.remark,
      };
      
      this.currPkg.push(temp);
      */
      this.currPkg.push(pkg);
    },
    cancelEdit() {
      this.$router.push({
        name: "classlist",
      });
    },
    stuAllChange(val) {
      this.stuAllMultSelection = val;
    },
    viewStu(stu) {
      this.$router.push({
        name: "detailStu",
        query: {
          id: stu.id,
        },
      });
    },
    handleStuAllSizeChange(val) {
      this.stuAllQueryParams.pageSize = val;
      this.fetchStuList();
    },
    handleStuAllCurrentChange(val) {
      this.stuAllQueryParams.page = val;
      this.fetchStuList();
    },
    stuAllQueryHandle(param) {
      // console.log(param);
      this.stuAllQueryParams.page = 1;

      this.queryTerms = param;
      this.fetchStuList();
    },
    addStu() {
      if (this.stuAllMultSelection.length == 0) {
        alert("请选择学生");
        return;
      }
      let stuId = [];
      for (let i in this.stuAllMultSelection) {
        stuId.push(`${this.stuAllMultSelection[i].id}`);
      }
      if (stuId.length > 0) {
        let params = {
          appId: this.$API.APPID,
          classId: `${this.currClassId}`,
          stuId: stuId,
          joinTime: nowDateToNowStr(),
        };
        this.eduAxiosPostRequest("/edu/eduAdmin/class/stu_save", params).then(
          (res) => {
            if (res != null) {
              this.$Message.success("添加成功!");
              this.fetchClsStu();
            }
          }
        );
      }
    },
    fetchClsStu() {
      let params = {
        appId: this.$API.APPID,
        id: `${this.currClassId}`,
        page: this.stuSelQueryParams.page,
        pageSize: this.stuSelQueryParams.pageSize,
      };
      if (this.queryTermsForClsStu != null) {
        if (this.queryTermsForClsStu.id != "") {
          params.stuId = this.queryTermsForClsStu.id;
        }
        if (this.queryTermsForClsStu.stuName != "") {
          params.stuName = this.queryTermsForClsStu.stuName;
        }
        if (this.queryTermsForClsStu.phone != "") {
          params.phone = filterMultyNum(this.queryTermsForClsStu.phone);
        }
        if (this.queryTermsForClsStu.weixinId != "") {
          params.weixinId = this.queryTermsForClsStu.weixinId;
        }
        if (this.queryTermsForClsStu.groupName != "") {
          params.groupName = this.queryTermsForClsStu.groupName;
        }
        if (this.queryTermsForClsStu.teacherId != "") {
          params.teacherId = parseInt(this.queryTermsForClsStu.teacherId);
        }
        if (
          this.queryTermsForClsStu.signupDate.length &&
          this.queryTermsForClsStu.signupDate.length == 2
        ) {
          if (
            this.queryTermsForClsStu.signupDate[0] != null &&
            this.queryTermsForClsStu.signupDate[1] != null
          ) {
            params.signupDate = [
              formatDateString(this.queryTermsForClsStu.signupDate[0]),
              formatDateString(this.queryTermsForClsStu.signupDate[1]),
            ];
          }
        }
        if (
          this.queryTermsForClsStu.expireDate &&
          this.queryTermsForClsStu.expireDate.length == 2
        ) {
          if (
            this.queryTermsForClsStu.expireDate[0] != null &&
            this.queryTermsForClsStu.expireDate[1] != null
          ) {
            if (
              this.queryTermsForClsStu.expireDate[0] == "2121-01-01" &&
              this.queryTermsForClsStu.expireDate[1] == "2121-01-01"
            ) {
              params.expireDate = ["", ""];
            } else {
              params.expireDate = [
                formatDateString(this.queryTermsForClsStu.expireDate[0]),
                formatDateString(this.queryTermsForClsStu.expireDate[1]),
              ];
            }
          }
        }
        if (
          this.queryTermsForClsStu.status !== null &&
          this.queryTermsForClsStu.status !== ""
        ) {
          params.status = this.queryTermsForClsStu.status;
        }
        if (
          this.queryTermsForClsStu.endTime &&
          this.queryTermsForClsStu.endTime.length == 2
        ) {
          if (
            this.queryTermsForClsStu.endTime[0] != null &&
            this.queryTermsForClsStu.endTime[1] != null
          ) {
            params.endTime = [
              formatDateString(this.queryTermsForClsStu.endTime[0]),
              formatDateString(this.queryTermsForClsStu.endTime[1]),
            ];
          }
        }
        // 入班时间
        if (
          this.queryTermsForClsStu.joinTime &&
          this.queryTermsForClsStu.joinTime.length == 2
        ) {
          if (
            this.queryTermsForClsStu.joinTime[0] != null &&
            this.queryTermsForClsStu.joinTime[1] != null
          ) {
            params.joinTime = [
              formatDateString(this.queryTermsForClsStu.joinTime[0]),
              formatDateString(this.queryTermsForClsStu.joinTime[1]),
            ];
          }
        }
      }

      this.eduAxiosPostRequest("/edu/eduAdmin/class/stu_list", params).then(
        (res2) => {
          if (res2 != null) {
            let m2 = JSON.parse(res2);
            this.stuSelData = m2.list;
            this.stuSelPageTotal = m2.pager.total;

            var vm = this;
            // console.log(vm.bjjksj, "667777777777");
            this.stuSelData.forEach(function (i, v) {
              // vm.formClass.signupDate = i.signupDate;
              // vm.formClass.expireDate1 = i.expireDate;
              if (vm.bjjksj <= i.joinTime) {
                // debugger
                vm.isWeek = false;
              } else {
                vm.isWeek = true;
              }
            });
          }
        }
      );
    },
    delStu() {
      if (this.stuSelMultSelection.length == 0) {
        alert("请先选择学生");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除？",
        content: "<ul><li>请确认是否删除所选学生</li></ul>",
        onOk: () => {
          let stuIds = [];
          for (let i in this.stuSelMultSelection) {
            stuIds.push(`${this.stuSelMultSelection[i].id}`);
          }
          let params = {
            appId: this.$API.APPID,
            stuId: stuIds,
            classId: this.currClassId,
          };
          this.eduAxiosPostRequest("/edu/eduAdmin/class/stu_del", params).then(
            (res) => {
              if (res != null) {
                this.$Message.success("删除成功!");
                this.fetchClsStu();
              }
            }
          );
        },
      });
    },
    stuSelQueryHandle(param) {
      this.stuSelQueryParams.page = 1;
      this.queryTermsForClsStu = param;
      this.fetchClsStu();
    },
    handleStuSelSizeChange(val) {
      this.stuSelQueryParams.pageSize = val;
      this.fetchClsStu();
    },
    handleStuSelCurrentChange(val) {
      this.stuSelQueryParams.page = val;
      this.fetchClsStu();
    },
    stuSelChange(val) {
      this.stuSelMultSelection = val;
    },
    lastStep() {
      this.step = 1;
    },
    finishEdit() {
      this.$router.push({
        name: "classlist",
      });
    },
    checkStartTime() {
      return compareTimeWithNow(this.formClass.startTime);
    },
    beginTimeChgHandle(val, type) {},
    finishTimeChgHandle(val, type) {},
    startTimeChgHandle(val, type) {
      this.checkStartTime();
    },
    viewPkg(pkg, type) {
      // debugger
      this.$router.push({
        name: "detailCourse",
        query: {
          id: pkg.pkgId, //課包id
          classId: this.currClassId, //班級id
          type: type,
        },
      });
    },
    checkTime(timeCheck) {
      var myDate = new Date().toLocaleDateString();
      var now = dateStrToMs1(myDate);
      var time = dateStrToMs(timeCheck);
      if (now <= time) {
        return true;
      } else {
        return false;
      }
    },
    classChgHandle(oldClassId, clsArr) {
      if (this.stuSelMultSelection.length == 0) {
        alert("请先选择学生");
        return;
      }
      let stuId = [];
      for (let i in this.stuSelMultSelection) {
        stuId.push(`${this.stuSelMultSelection[i].id}`);
      }
      let params = {
        appId: this.$API.APPID,
        stuId: stuId,
        oldClassId: oldClassId[0] || "",
        classId: clsArr.classId.toString(),
        joinTime: nowDateToNowStr(),
      };
      // console.log(params);
      this.eduAxiosPostRequest("/edu/eduAdmin/class/stu_save", params).then(
        (res) => {
          if (res != null) {
            this.$Message.success("操作成功!");
            this.fetchClsStu();
          }
        }
      );
    },
    transToStr(val) {
      return formatDateString(val);
    },
    editClassStartTimeConfrim(val) {
      //修改开课时间
      // 判断是否是转班生
      // let statuShow = [];
      // for (let i in this.stuSelMultSelection) {
      //   statuShow.push(`${this.stuSelMultSelection[i].status}`);
      // }
      // if (statuShow.includes(2)) {
      //   console.log("该学员已经离开班级，不可能修改开课时间");
      // } else {
      //   console.log("不存在");
      // }
      // 取学员n结课时间最小值 学员课程起始时间不允许晚于学员结课时间
      let allendTime = [];
      for (let i in this.stuSelMultSelection) {
        allendTime.push(`${dateStrToMs(this.stuSelMultSelection[i].endTime)}`);
      }
      allendTime.sort(function (a, b) {
        return a - b;
      });

      var effectEndTime1 = allendTime[0];
      let startTime = dateStrToMs(val.startTime);
      let endTime = dateStrToMs(val.endTime);
      let effectStartTime = dateStrToMs(val.effectStartTime);
      if (effectStartTime < startTime) {
        alert("学员课程起始时间不允许早于班级起始时间");
        return;
      } else if (effectStartTime > endTime) {
        alert("学员课程起始时间不允许晚于班级结课时间");
        return;
      } else if (effectStartTime > effectEndTime1) {
        alert("学员课程起始时间不允许晚于学员结课时间");
        return;
      } else {
        let stuId = [];
        for (let i in this.stuSelMultSelection) {
          stuId.push(`${this.stuSelMultSelection[i].id}`);
        }
        let params = {
          appId: this.$API.APPID,
          stuId: stuId,
          classId: `${val.currEditClassId}`,
          startTime: formatDate(effectStartTime, "yyyy-MM-dd"),
        };
        this.eduAxiosPostRequest("/edu/eduAdmin/class/stu_update", params).then(
          (res) => {
            if (res != null) {
              this.$Message.success("操作成功!");
              this.fetchClsStu();
            }
          }
        );
      }
    },
    editClassEndTimeConfrim(val) {
      // 学员在班的开课时间(取最大值的)
      let allstartTime = [];
      for (let i in this.stuSelMultSelection) {
        allstartTime.push(
          `${dateStrToMs(this.stuSelMultSelection[i].startTime)}`
        );
      }
      allstartTime.sort(function (a, b) {
        return a - b;
      });
      var startTimeMax = allstartTime[allstartTime.length - 1];
      let starTime = startTimeMax; //学员在班的开课时间
      // 控制有效期(取最小值的)
      let allExpireDate = [];
      for (let i in this.stuSelMultSelection) {
        allExpireDate.push(
          `${dateStrToMs(
            this.stuSelMultSelection[i].expireDate || "2121-01-01"
          )}`
        );
      }
      allExpireDate.sort(function (a, b) {
        return a - b;
      });

      var expireDate1 = allExpireDate[0];
      let effectEndTime = dateStrToMs(val.effectEndTime); //课程结束时间
      let classEndTime = dateStrToMs(val.endTime); //班级结束时间
      if (effectEndTime < starTime) {
        alert("结课时间不允许早于学员在班的开课时间");
        return;
      } else if (effectEndTime != classEndTime && effectEndTime > expireDate1) {
        // debugger
        alert("请选择在会员有效期内的结课时间");
        return;
      }
      let stuId = [];
      for (let i in this.stuSelMultSelection) {
        stuId.push(`${this.stuSelMultSelection[i].id}`);
      }

      let params = {
        appId: this.$API.APPID,
        stuId: stuId,
        classId: `${val.currEditClassId}`,
        endTime: formatDate(effectEndTime, "yyyy-MM-dd"),
      };
      this.eduAxiosPostRequest("/edu/eduAdmin/class/stu_update", params).then(
        (res) => {
          if (res != null) {
            this.$Message.success("操作成功!");
            this.fetchClsStu();
          }
        }
      );
    },
    editjoinTimeConfrim(val) {
      let stujoinTime = dateStrToMs(val.stujoinTime); //入班时间
      // let signupDate = dateStrToMs(this.formClass.signupDate); //报名时间
      // let expireDate1 = dateStrToMs(this.formClass.expireDate1); //会员有效期
      // 学员报名时间(取最大值的)
      let allsignupDate = [];
      for (let i in this.stuSelMultSelection) {
        allsignupDate.push(
          `${dateStrToMs(this.stuSelMultSelection[i].signupDate)}`
        );
      }
      allsignupDate.sort(function (a, b) {
        return a - b;
      });
      var signupDateMax = allsignupDate[allsignupDate.length - 1];
      let signupDate = signupDateMax;

      // debugger
      // 控制有效期(取最小值的)
      let allExpireDate = [];
      for (let i in this.stuSelMultSelection) {
        allExpireDate.push(
          `${dateStrToMs(
            this.stuSelMultSelection[i].expireDate || "2121-01-01"
          )}`
        );
      }
      allExpireDate.sort(function (a, b) {
        return a - b;
      });

      var expireDate1 = allExpireDate[0];
      if (stujoinTime < signupDate) {
        //  debugger
        alert("入班时间不允许早于学员的报名时间");
        return;
      } else if (stujoinTime > expireDate1) {
        alert("入班时间不允许晚于学员的会员有效期");
        return;
      }
      let stuId = [];
      for (let i in this.stuSelMultSelection) {
        stuId.push(`${this.stuSelMultSelection[i].id}`);
      }
      let params = {
        appId: this.$API.APPID,
        stuId: stuId,
        classId: `${val.currEditClassId}`,
        joinTime: formatDate(stujoinTime, "yyyy-MM-dd"),
      };
      this.eduAxiosPostRequest("/edu/eduAdmin/class/stu_update", params).then(
        (res) => {
          if (res != null) {
            this.$Message.success("操作成功!");
            this.fetchClsStu();
          }
        }
      );
    },
    checkWeek(joinTime) {
      console.log(joinTime, "TIme");
      if (joinTime) {
        let joinWeek = calcWeek(joinTime);
        let startWeek = calcWeek(this.formClass.startTime);
        if (joinWeek != null && startWeek != null) {
          if (joinWeek <= startWeek) {
            return 1;
          } else {
            return joinWeek - startWeek + 1;
          }
        } else {
          return "?";
        }
      } else {
        return "?";
      }
    },
    // checkWeekDiff(joinTime, startTime, endTime, count) {
    //   var joinTimeDate = moment(joinTime).unix();
    //   var startTimeDate = moment(this.formClass.startTime).unix();
    //   var endTimeDate = moment(endTime).unix();
    //   var count = this.formClass.classCount;

    //   if (joinTimeDate <= startTimeDate) {
    //     return 1;
    //   } else if (joinTimeDate >= endTimeDate) {
    //     return count;
    //   } else {
    //     var a = Math.abs(moment(startTime).diff(moment(joinTime), "days"));
    //     // console.log(a/7, 'da/')
    //     // console.log(joinTime, 'TIme')
    //     if (joinTime != null && startTime != null) {
    //       return Math.ceil(a / 7);
    //     } else {
    //       return "?";
    //     }
    //   }
    // },
    /**
     * 描述
     * @date 2021-04-26
     * @param {any} joinTime // 入学时间
     * @param {any} startTime // 课程总开始时间
     * @param {any} endTime // 班级结束时间
     * @param {any} count // 总周数
     * @returns {any}
     */
    checkWeekDiff(joinTime, startTime, endTime, count) {
      var joinTimeDate = moment(joinTime).unix();
      var startTimeDate = moment(startTime).unix();
      var endTimeDate = moment(endTime).unix();
      if (joinTimeDate <= startTimeDate) {
        return 1;
      } else if (joinTimeDate >= endTimeDate) {
        return count;
      } else {
        // debugger
        var a = Math.abs(moment(startTime).diff(moment(joinTime), "days"));
        // console.log(a/7, 'da/')
        // console.log(joinTime, 'TIme')
        if (joinTime != null && startTime != null) {
          if ((a / 7) % 1 != 0) {
            // console.log("不是整数");
            return Math.ceil(a / 7);
          } else if ((a / 7) % 1 === 0) {
            // console.log("是整数");
            return Math.ceil(a / 7) + 1;
          }
        } else {
          return "?";
        }
      }
    },
    checkStuEndTime(stuEndTime, stuExpireDate) {
      let str = "";
      if (stuEndTime != null) {
        let stuEndTimeNum = dateStrToMs(stuEndTime);
        let classEndTimeNum = dateStrToMs(this.formClass.finishTime);
        if (classEndTimeNum == stuEndTimeNum) {
          str = "班级毕业";
        } else {
          str = stuEndTime;
        }
        if (stuExpireDate != null) {
          let stuExpireTimeNum = dateStrToMs(stuExpireDate);
          if (stuExpireTimeNum < stuEndTimeNum) {
            str = `会员有效期：(${stuExpireDate})`;
          }
        }
      } else {
        return "";
      }

      return str;
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            // console.log(response);
            if (response.data.rc == "0") {
              if (
                address.indexOf("stu_save") == -1 &&
                address.indexOf("stu_del") == -1 &&
                address.indexOf("stu_update") == -1
              ) {
                resolve(JSON.stringify(response.data.data));
              } else {
                resolve(JSON.stringify(response.data.msg));
              }
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
@import "../fyd-style";
@import "../commonEdu";
</style>



// WEBPACK FOOTER //
// addClass.vue?e980bc58